import {Base} from './Base';

export class Dropdown extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.isOpen = false;
    this.init();
  }

  init() {
    const { menu, trigger } = this.refs;
    trigger.addEventListener('click', this.handleClick);
  }

  handleClick = (e) => {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  };

  open = () => {
    const { trigger } = this.refs;
    this.isOpen = true;
    this.element.classList.add('active');
    trigger.setAttribute('aria-expanded', true);
    this.element.addEventListener('focusout', this.handleFocusOut);
    window.addEventListener('keydown', this.handleKey, true);
  };

  close = () => {
    const { trigger } = this.refs;
    this.isOpen = false;
    this.element.classList.remove('active');
    trigger.setAttribute('aria-expanded', false);
    this.element.removeEventListener('focusout', this.handleFocusOut);
    window.removeEventListener('keydown', this.handleKey, true);
  };

  handleFocusOut = (e) => {
    // if the element clicked is outside of this dropdown
    if (!e.relatedTarget || e.relatedTarget.closest('.dropdown') !== this.element) {
      setTimeout(this.close, 0);
    }
  };

  handleKey = (e) => {
    if (e.defaultPrevented) {
      return; // Do nothing if the event was already processed
    }

    if (e.key === 'Esc' || e.key === 'Escape') {
      this.close();
      const { trigger } = this.refs;
      trigger.blur();
      e.preventDefault();
    }
  };

  cleanup() {
    const { menu, trigger } = this.refs;
    trigger.removeEventListener('click', this.handleClick);
  }
}
